import { Suspense } from 'react';
import { createCrumbHandle } from '../../utilities/auth';
import { PageLoading } from '../../core-components/theme/components/Screen';
import { PLANT_RULES, access, param } from '../../access';
import FMListing from '../../pages/FileManager/FMListing';


const fileManagementRoute = [
  {
    path: '/file-management/:assetId',
    handle: createCrumbHandle('File Management'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<PageLoading />}>
            <FMListing />
          </Suspense>
        ),
        handle: access(PLANT_RULES.documents, param('assetId')),
      },
    ]
  },
];

export default fileManagementRoute;
